import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

const ACCENTS = {
  red:    { primary: "#B91C1C", dark: "#7F1D1D", ring: "#EF4444" },
  orange: { primary: "#EA580C", dark: "#9A3412", ring: "#F97316" },
  green:  { primary: "#15803D", dark: "#14532D", ring: "#22C55E" },
  blue:   { primary: "#1D4ED8", dark: "#1E3A8A", ring: "#3B82F6" },
  purple: { primary: "#7E22CE", dark: "#581C87", ring: "#A855F7" },
  amber:  { primary: "#B45309", dark: "#78350F", ring: "#F59E0B" },
};

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("kr-theme-mode") || "light");
  const [accent, setAccent] = useState(() => localStorage.getItem("kr-theme-accent") || "red");

  useEffect(() => {
    const root = document.documentElement;
    if (mode === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("kr-theme-mode", mode);
  }, [mode]);

  useEffect(() => {
    const root = document.documentElement;
    const a = ACCENTS[accent] || ACCENTS.red;
    root.style.setProperty("--kr-orange", a.primary);
    root.style.setProperty("--kr-orange-dark", a.dark);
    root.style.setProperty("--kr-ring", a.ring);
    localStorage.setItem("kr-theme-accent", accent);
  }, [accent]);

  const toggle = () => setMode(m => m === "dark" ? "light" : "dark");
  const value = { mode, setMode, toggle, accent, setAccent, accents: Object.keys(ACCENTS) };
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) return {
    mode: "light", setMode: () => {}, toggle: () => {},
    accent: "red", setAccent: () => {}, accents: Object.keys(ACCENTS),
  };
  return ctx;
}
